import { render, staticRenderFns } from "./ImportWorkflowModel.vue?vue&type=template&id=5bd04f29&scoped=true&"
import script from "./ImportWorkflowModel.vue?vue&type=script&lang=js&"
export * from "./ImportWorkflowModel.vue?vue&type=script&lang=js&"
import style0 from "./ImportWorkflowModel.vue?vue&type=style&index=0&id=5bd04f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd04f29",
  null
  
)

export default component.exports